<template>
  <v-layout>
    <div>
      <vue-element-loading :active="$checkingAuthState" />
    </div>
    <VHomeVideo />
    <VHomeJumbotron
      v-if="!$checkingAuthState"
    ></VHomeJumbotron>

    <VProductsSlider
      v-if="!$checkingAuthState"
      :title="$t('home.top')"
      :see-all-link="{name: 'product_list', params: {listType: 'topfarma'}}"
      source="drugs/REQUEST_DRUGS_TOP"
      class="home_slider mt-4"
    />

    <VProductsSlider
      v-if="!$checkingAuthState"
      :title="$t('home.top_derma')"
      :see-all-link="{name: 'product_list', params: {listType: 'topderma'}}"
      source="drugs/REQUEST_DRUGS_TOP_DERMA"
      class="home_slider mt-4"

    />

    <VProductsSlider
      v-if="!$checkingAuthState"
      :title="$t('home.top_generic')"
      :see-all-link="{name: 'product_list', params: {listType: 'topgeneric'}}"
      source="drugs/REQUEST_PHDRUGS_TOP_GENERIC"
      class="home_slider mt-4"
      hide_on_no_results
    />
    <!-- <VProductsSlider
      v-if="!$checkingAuthState"
      :title="$t('home.generic_packs_offers')"
      :see-all-link="{name: 'product_list', params: {listType: 'generic_packs_offers'}}"
      source="drugs/REQUEST_GENERIC_PACKS_OFFERS"
      class="home_slider mt-4"
    /> -->
  </v-layout>
</template>


<script>
import VLayout from "@/layouts/Default";
import VProductsSlider from "@/components/VProductsSlider";
import VHomeJumbotron from "@/components/VHomeJumbotron";
import VHomeVideo from "@/components/VHomeVideo";

export default {
  components: {
    VLayout,
    VProductsSlider,
    VHomeJumbotron,
    VHomeVideo,
  },
  fallbackI18n: {
    messages: {
      und: {
        home: {
          top_derma: "Top Dermatology",
          top_speciality: "Top Specialty Drugs",
          top_generic: "Top Generic Drugs",
          top: "Top Drugs",
          generic_packs_offers: "Generic Packs Offers",
        },
      },
    },
  },
};
</script>


<style>
.home_slider {
}
</style>
